import React, { useEffect, useState } from "react";
import { Box, Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";

import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EmployeeModel from "./EmployeeModel";

import {
  EmployeeListing,
  EmployeeSearch,
  employeeFindById,
  updateStatusAPI,
} from "../../../services/employee/EmployeeService";
import SearchBar from "../../../../common/components/FormFields/SearchBar";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import CommonDynamicTablePagination from "../../../../common/components/CommonTable/CommonDynamicTablePagination";


export default function EmployeeMaster() {
  const [dataResult, setDataResult] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [count, setCount] = useState();
  const [edit, setEdit] = useState(false);
  const [dataEdit, setDataEdit] = useState({});
  const [deleteId, setDeleteId] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState();
  const [openChild, setOpenChild] = React.useState(false);
  const [editdatafetch, setEditdatafetch] = React.useState({});
  const [searchBar, setSearchBar] = React.useState("");
  const [options, setOptions] = React.useState([]);
  const [searchString, setSearchString] = React.useState("");
  const [searchId, setSearchId] = React.useState(null);
  const [openConfi, setOpenConfi] = useState(false);
  const [employyDetails, setEmployeeDetails] = useState();

  //Employee Modal
  const [openEmployeeModel, setOpenEmployeeModel] = useState(false);
  const handleOpen = () => setOpenEmployeeModel(true);
  const handleClose = () => setOpenEmployeeModel(false);

  const handleOpenConfirm = () => {
    setOpenConfi(true);
  };
  const handleCloseConfirm = () => {
    setOpenConfi(false);
  };
  const handelOpenChild = () => setOpenChild(true);
  const handleCloseChild = () => {
    if (openChild) {
      setOpenChild(false);
    }
  };

  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  }));

  const RenderActions = (row, index) => {
    return (
      <div className="flex ">
        <div>
          <Tooltip title="Edit">
            <div className="text-blue-500 mr-1">
              <DriveFileRenameOutlineIcon
                onClick={(e) => {
                  setOpenEmployeeModel(true);
                  editRow(row);
                  // props.setSelectedIndex(index);
                  setEdit(true);
                }}
              />
            </div>
          </Tooltip>
        </div>
        <div>
          <Tooltip title="Delete">
            <a
              href="##"
              className="text-red-500 mr-3"
            // onClick={() => deleteRow(row, index)}
            >
              {<DeleteOutlineOutlinedIcon />}
            </a>
          </Tooltip>
        </div>
      </div>
    );
  };

  //findById API Function
  // const editRow = (row) => {
  //   console.log("riow", row);
  //   employeeFindById(row["Employee ID"]).then((response) => {
  //     setEditdatafetch(response.data.result);
  //   });
  // };

  const editRow = (row) => {
    const id = row.Id || row.id;

    if (!id) return;

    employeeFindById(id).then((response) => {
      setEditdatafetch(response.data.result);
      setOpenEmployeeModel(true);
    });
  };

  // Listing API Function
  const populateTable = (forPagination) => {
    let searchObj = {
      page: !forPagination ? 1 : page,
      // employeeId: searchId ? searchId : null,
      // searchString: searchBar ? searchBar : null,
      searchName: searchBar?.trim() || "",
      size: rowsPerPage,
    };
    EmployeeListing(searchObj)
      .then((response) => response.data)
      .then((res) => {
        console.log("Patient information by id is ", res);
        if (forPagination) {
          setDataResult((prevData) => [...prevData, ...res.result]);
        } else {
          setDataResult(res.result);
          setPage(0);
        }
        setCount(res.count);
      });
    // .catch(() => {
    //   showSpinner(false);
    //   showRecordWarning(true);
    // });
  };

  //Autosearch API Function
  const handleChange = (autoSearchString) => {
    setSearchString(autoSearchString); // only for typing

    if (autoSearchString !== "") {
      EmployeeSearch(autoSearchString)
        .then((response) => response.data)
        .then((res) => {
          setOptions(res.result);
        });
    } else {
      setSearchBar(""); // clear only
    }
  };

  const searchFilde = (value) => {
    console.log("selected:", value);

    if (!value) {
      setSearchBar("");
    } else if (value?.label) {
      setSearchBar(value.label);
    }
  };

  useEffect(() => {
    populateTable()
  }, [searchBar])
  return (
    <div>
      <Box sx={{ display: "flex" }}>
      

        <Box component="main" sx={{ flexGrow: 1, p: 3, width: "100%" }}>
   

          <div className="w-full mx-auto ">
            <h1 className="text-xl text-black font-Poppins lg:block  md:block">
              Employee
            </h1>
            <div>
              <div className="flex justify-between w-full items-center mt-2">
                <div className="flex items-center w-full gap-2">


                  <div className=" flex items-center gap-2 text-start w-full xl:w-3/4">
                    {/* searchable */}
                    <SearchBar
                      type="button"
                      name="SearchableSelect"
                      placeholder="Search By Employee Name"
                      handleInputChange={handleChange}
                      dataArray={options}
                      searchIcon={true}
                      onChange={searchFilde}
                      isClearable={true}
                    />
                    <div className="flex ">
                      <div className="flex items-center">
                        <CommonButton
                          searchIcon={true}
                          className="bg-blue-800 text-white"
                          type="button"
                          onClick={() => populateTable()}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Modal and table name start */}
                <div className="flex w-full justify-end">
                  <CommonButton
                    label="+ Add New"
                    className="bg-green-500 text-white"
                    onClick={() => {
                      handleOpen();
                      setEditdatafetch(null);
                      setDataEdit({});
                      setEdit(false);
                    }}
                  />
                </div>

                {/* Backdrop component to disable the screen after submitting the form */}
              </div>
              <hr className="w-full border-t-1 border-[#0B83A5] my-2" />
              {dataResult.length > 0 ? (
                <CommonDynamicTablePagination
                  dataResult={dataResult}
                  page={page}
                  setPage={setPage}
                  rowsPerPage={rowsPerPage}
                  count={count}
                  renderActions={RenderActions}
                  removeHeaders={[
                    "Id",
                    "empBenefits",
                    "Previous History Table",
                    "empExpDetails",
                    "empEducation",
                    "empReference",
                    "empDependentDetails",
                    "empExperienceDetails",
                  ]}
                  populateTable={populateTable}
                  actionsRequired={true}
                  highlightRow={false}
                // handleStatusChange={handleStatusChange}
                />
              ) : null}
              <EmployeeModel
                open={openEmployeeModel}
                setEdit={setEdit}
                editRow={editRow}
                setOpen={setOpenEmployeeModel}
                handleClose={handleClose}
                handleOpen={handleOpen}
                edit={edit}
                dataResult={dataResult}
                setDataResult={setDataResult}
                dataEdit={dataEdit}
                setDataEdit={setDataEdit}
                selectedIndex={selectedIndex}
                editdatafetch={editdatafetch}
                populateTable={populateTable}
              />
            </div>
          </div>
          {/* <ConfirmationModal
          confirmationOpen={openChild}
          confirmationHandleClose={handleCloseChild}
          confirmationSubmitFunc={deleteRecord}
          confirmationLabel="Confirmation"
          confirmationMsg="Are you sure want to delete this record ?"
          confirmationButtonMsg="Delete"
        /> */}
        </Box>
      </Box>
    </div>
  );
}
